'use client';
import { cx } from '@linaria/core';
import { useParams } from 'next/navigation';
import React, { useMemo } from 'react';

import { SubHeadline, Text } from '~components/Typography';
import { useAccountContext } from '~context/account';
import { usePaywallContext } from '~context/paywall';
import { PaymentReason } from '~features/annals/enums/payment';
import annalsCheckout from '~features/annals/hooks/checkout';
import { useTranslations } from '~i18n/hooks';
import { DropdownElement } from '~shared/ui/atoms/Dropdown';
import { NeuronImage } from '~shared/ui/atoms/NeuronImage';

import { SubscriptionDropdownElement, TileElement } from './styles';

export const SubscriptionItem = () => {
	const t = useTranslations('ProfileMenu');

	const { openPaywall } = usePaywallContext();

	const { balance } = useAccountContext();
	const { recipientId: botClientId } = useParams<{ recipientId?: string }>();
	const reasonType = annalsCheckout.usePaymentReasonType();
	const handleClick = useMemo(
		() =>
			openPaywall({
				reason: PaymentReason.LeftMenu,
				reasonType,
				prefer: 'subscription',
				botClientId,
			}),
		[botClientId, openPaywall, reasonType]
	);

	return (
		<>
			<DropdownElement
				data-name="subscription-promo-item"
				data-coc={true}
				onClick={handleClick}
				className={cx(SubscriptionDropdownElement, TileElement)}
			>
				<SubHeadline size="S" color="grey-95-solid" align="left">
					{t('upgradeToPremiumTitle')}
				</SubHeadline>
				<Text color="rose-58-solid" size="S" align="left">
					{t('upgradeToPremiumSubtitle')}
				</Text>
			</DropdownElement>
			<DropdownElement
				data-name="neurons-item"
				icon={<NeuronImage />}
				hint={t('neuronsSubtitle')}
				onClick={openPaywall({
					reason: PaymentReason.LeftMenu,
					reasonType,
					prefer: 'neurons',
					botClientId,
				})}
			>
				<Text size="M" align="left">
					{new Intl.NumberFormat().format(balance)} {t('neuronsTitle')}
				</Text>
			</DropdownElement>
		</>
	);
};
